export const GET_RESERVATIONS = 'GET_RECENT_DASHBOARD_RESERVATIONS'
export const SET_RESERVATIONS = 'SET_RECENT_DASHBOARD_RESERVATIONS'

export const GET_RECENT_NEWS = 'GET_RECENT_NEWS'
export const SET_RECENT_NEWS = 'SET_RECENT_NEWS'
